import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useFetchData from '../../hooks/useFetchData';
import { useLoading } from '../../context/LoadingContext';
import useFullScreen from '../../hooks/useFullscreen';
import styles from './capsule.module.scss';
import Toolbar from '../Toolbar/Toolbar';
import { ContentLayoutProvider, useContentLayout } from '../../context/ContentLayout';
import { Helmet } from 'react-helmet-async';

const dilutionsData = [
    {
        letter: "A",
        encoding: "! Atténuer, Contraire légitime, Efficace",
        sort: 1
    },
    {
        letter: "R",
        encoding: "! Renforcer, normal, Efficace",
        sort: 2
    },
    {
        letter: "S",
        encoding: "! Syntoniser, Dans son assertion allégorique, Efficace",
        sort: 3
    },
    {
        letter: "E",
        encoding: "! Effluence, Normal, Répétition",
        sort: 4
    },
    {
        letter: "T-08 E",
        encoding: "! 40/3.2, Profond, Interaction",
        sort: 5
    },
    {
        letter: "T-10 E",
        encoding: "! 40/4, Transmutation , réactiver",
        sort: 6
    },
    {
        letter: "T-12 E",
        encoding: "! 40/4.8, Interaction, réactiver",
        sort: 7
    },
    {
        letter: "Sans",
        encoding: "! 1:1, Dans son assertion allégorique, Efficace  ",
        sort: 8
    },
    // Ajoutez d'autres dilutions au besoin
];

const dilutions = {};
dilutionsData.forEach((dilution) => {
    dilutions[dilution.letter] = dilution;
});
const CapsuleDisplayed = () => {
    const { id } = useParams();
    const { data, error, isLoading } = useFetchData(`/capsules/configurations/${id}`)
    const { layoutConfig, checkColumns, resetFontsize, resetColumn, checkFontsize } = useContentLayout(); // Utilisez le contexte
    const [currentDilution, setCurrentDilution] = useState(null);
    const [isDisplay, setIsDisplay] = useState(true);
    const containerRef = useRef(null);

    const getFirstDilution = () => {
        // Get all dilutions of objects in data and sort it
        if (!data) { return }

        const sortedDilutions = [...new Set(data.configuration.content.map((item) => item.dilution !== null ? item.dilution.label : item.mixture.defaultDilution.label))].sort((a, b) => {
            return dilutions[a].sort - dilutions[b].sort
        });
        setCurrentDilution(dilutions[sortedDilutions[0]])
    }


    const sortedData = useMemo(() => {
        if (!isLoading) {
            const sortedDilutions = [...new Set(data.configuration.content.map((item) => item.dilution !== null ? item.dilution.label : item.mixture.defaultDilution.label))].sort((a, b) => {
                return dilutions[a].sort - dilutions[b].sort
            });
            if (!currentDilution) {
                setCurrentDilution(dilutions[sortedDilutions[0]])
            }
            return currentDilution ? data.configuration.content.filter((item) => {
                const dilution = item.dilution !== null ? item.dilution.label : item.mixture.defaultDilution.label
                return dilution === currentDilution.letter
            }) : data.configuration.content.filter((item) => {
                const dilution = item.dilution !== null ? item.dilution.label : item.mixture.defaultDilution.label
                return dilution === sortedDilutions[0]
            })
        }

    }, [data, currentDilution, isLoading]);

    const toggleToolbar = (event) => {
        if (event.ctrlKey && event.code === 'KeyA') {
            setIsDisplay(!isDisplay);
        }
    };

    const resetContentStyles = () => {
        // Réinitialisez les styles CSS pour afficher le contenu en une seule colonne.
        const container = containerRef.current;
        if (container) {
            container.style.columnCount = 1;
        }
    };

    const checkWindowSize = () => {
        resetContentStyles(); // Réinitialisez la disposition à une colonne.
    };

    useEffect(() => {
        document.addEventListener('keydown', toggleToolbar);

        return () => {
            document.removeEventListener('keydown', toggleToolbar);
        };
    }, [isDisplay]); // Assurez-vous que ce code s'exécute une seule fois lors du montage

    useEffect(() => {
        if (!isLoading) {
            getFirstDilution()
        }
    }, [data, isLoading]);

    useEffect(() => {
        checkColumns(); // Exécutez la vérification initiale.
        checkFontsize();
    }, [sortedData, currentDilution]);
    if (isLoading) {
        return <p>Chargement...</p>
    }
    return (
        <>
            <Helmet>
                <title>ENCODING</title>
            </Helmet>

            {error && <p>{error.request.status === 403 ? 'Unauthorized' : error.message}</p>}
            {isDisplay && (
                <div className={styles.toolbarContainer}>
                    <Toolbar checkWindowSize={checkWindowSize} fontSize={layoutConfig.fontSize} columnCount={layoutConfig.columns} />
                    {data && dilutionsData.sort((a, b) => a.sort - b.sort).map((dilution, index) => {
                        if (data.configuration.content.some((item) => item.dilution !== null ? item.dilution.label === dilution.letter : item.mixture.defaultDilution.label === dilution.letter)) {
                            return (
                                <button style={{ background: currentDilution === dilution ? '#63cdf5' : 'white' }} key={index} onClick={() => {
                                    if (currentDilution !== dilution) {
                                        console.log('change dilution')
                                        setCurrentDilution(dilution);
                                        resetColumn();
                                        resetFontsize();
                                    }
                                }}>
                                    {dilution.letter}
                                </button>
                            );
                        }
                        return null;
                    })}
                </div>
            )}

            <div style={{ padding: '20px' }}>


                <div ref={containerRef} className={styles.container} style={{ fontSize: `${layoutConfig.fontSize}px`, columnCount: layoutConfig.columns }}>

                    {sortedData && sortedData.map((item, index) => {
                        const encodage = item.dilution ? item.dilution.encodage : item.mixture.defaultDilution.encodage
                        console.log(encodage)
                        return (
                            <div key={index}>
                                <p> {item.mixture.subCategory.toUpperCase()}</p>
                                <p>{item.mixture.name} {encodage} {"{"}</p>
                                {item.mixture.reagents.map((reagents, index) => (
                                    <p key={`reagent_${index}`}>{reagents}</p>
                                ))}
                                <p>{"}"}</p>
                                <br />
                                <br />
                            </div>
                        )
                    })}
                </div>
            </div>

        </>
    );
};
const ConfigurationEncoder = () => {
    return (
        <ContentLayoutProvider>
            <CapsuleDisplayed />
        </ContentLayoutProvider>
    )
}

export default ConfigurationEncoder;
